import React from "react";

interface AuthLayoutProps{
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <main className="authLayoutMain no-scrollbar">
      <section className="authLayoutSection no-scrollbar">
        {children}
      </section>
    </main>
  );
};

export default AuthLayout;
